module.exports = __webpack_public_path__ + "static/media/межсезонье.ce5c41b9.jpg";